export default __webpack_public_path__ + "static/pragicts-secops-services-casb-184c2e060e9eb766652dd986ba1a4f14.jpg";